import http from 'MeetingsBase/http/apiClient';
import { EMAIL_ENDPOINT } from 'MeetingsAdmin/constants/endpoints';
export function sendEmbedCodeEmail(toAddress, linkId) {
  return http.put(`${EMAIL_ENDPOINT}/embed-code?toAddress=${toAddress}&linkId=${linkId}`);
}
export function sendTestConfirmationEmail(linkId) {
  return http.post(`${EMAIL_ENDPOINT}/send-test?linkId=${linkId}`);
}